import { useTheme } from '@material-ui/core';

const LogoFull = () => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <img
      src={isDark ? '/flow-logofull-white.svg' : '/flow-logofull-indigo.svg'}
      alt="Flow"
      style={{ display: 'block', width: '100%', maxWidth: 180 }}
    />
  );
};

export default LogoFull;
